import { getBrandName } from "~/utils/white-label";

const labels = {
  WELCOME_BACK: "Welcome back!",
  EMAIL: "Email",
  INVALID_EMAIL: "Invalid email address",
  PASSWORD: "Password",
  ENTER_YOUR_EMAIL: "Enter your email",
  ENTER_YOUR_PASSWORD: "Enter your password",
  LOG_IN: "Log in",
  FORGOT_YOUR_PASSWORD: "Forgot your password?",
  THIS_FIELD_CANNOT_BE_EMPTY: "This field cannot be left empty",
  DONT_HAVE_AN_ACCOUNT: "Don`t have an account?",
  SIGN_UP: "Sign up",
  WELCOME: `Welcome to ${getBrandName()}!`,
  PASSWORD_MUST_CONTAIN_AT_LEAST_6_CHARACTERS:
    "Password must contain at least 6 characters",
  PASSWORD_RESET: "Password reset",
  RESET_PASSWORD: "Reset password",
  ENTER_YOUR_EMAIL_CONFIRMATION:
    "Enter your email and we'll send password reset instructions.",
  FORGOT_PASSWORD: "Forgot your password?",
  KNOW_YOUR_PASSWORD: "Know your password?",
  BACK_TO_LOGIN: "Back to login",
  RECOVERY_LINK_SENT: "Recovery link sent",
  GET_RECOVERY_LINK_SENT_INFO: (successResetEmail: string) => {
    return `If an account exists for ${successResetEmail}, you will get an email with instructions on resetting your password. If it doesn't arrive, be sure to check your spam folder.`;
  },
  CREATE_NEW_PASSWORD: "Create new password",
  NEW_PASSWORD: "New password",
  CONFIRM_PASSWORD: "Confirm password",
  PASSWORDS_DONT_MATCH: "Passwords don't match",
  FIRST_NAME: "First name",
  LAST_NAME: "Last name",
  ALREADY_HAVE_AN_ACCOUNT: "Already have an account?",
  PASSWORD_VALIDATION_MESSAGE: "Password must consist 6 characters",
  CURRENT_PLAN: "Current Plan",
  YOUR_PLAN_USAGE: "Your Plan Usage",
  DASHBOARD: "Dashboard",
  TEAM_MEMBERS: "Team Members",
  API_KEYS: "API Keys",
  SERVICES: "Services",
  BILLING: "Billing",
  SETTINGS: "Settings",
  HELP_CENTER: "Help Center",
  NOTIFICATIONS: "Notifications",
  LOG_OUT: "Log out",
  CANCEL_CONFIRMATION: "Confirm Cancelation",
  CANCEL_SUBSCRIPTION: "Cancel Subscription",
  TYPE_CANCELATION_PLACEHOLDER: "Type “Сancel Subscription” to confirm",
  CANCELATION_WARNING:
    "Pay attention! Before cancelling your subscription, make sure your domain has been transferred to another hosting system. Otherwise, this may disrupt the functionality of your website",
  CANCEL: "Cancel",
  CANCELATION_MESSAGE: (date: string) => {
    return `Seems like you are going to cancel your subscription. Your subscription will be canceled by the end of your billing period on ${date}. You can change your mind any time before this date.`;
  },
  CANCEL_VALIDATION: "Input does not match “Cancel Subscription”",
  BEFORE_YOU_GO: "Before You Go",
  BEFORE_YOU_GO_MESSAGE:
    "We are sorry to see you, and are interested in learning more about why you decided to cancel the subscription. Your responses will be kept confidential and will not be used for any other purposes than research conducted by our company.",
  CANCEL_REASON: "What was the main reason for canceling?",
  PRICE_PER_UNIT: "Price per unit",
  ADD_PAYMENT_METHOD: "Add Payment Method",
  UPDATE_PAYMENT_METHOD: "Update Payment Method",
  MANAGE_ADD_ONS: "Manage Add-ons",
  VIEW_INVOICE_ESTIMATE: "View invoice estimate",
  FREE_LIMIT_AVAILABLE: "Free allowance included",
  NO_FREE_LIMIT: "Billed per unit",
  TYPE_HERE: "Type here...",
  COMMENT_OPTIONAL: "Comment (optional)",
  ANYTHING_YOU_WANT_TO_SHARE: "Anything you want to share...",
  SUBMIT_FEEDBACK: "Submit Feedback",
  EDIT_SUBSCRIPTION: "Edit Subscription",
  CHANGE_PLAN: "Change Plan",
  IT_WAS_A_PLEASURE_TO_WORK_WITH_YOU: "It was a pleasure to work with you!",
  GOT_IT: "Got it!",
  PLEASE_SELECT_REASON: "Please select a reason",
  PLEASE_PROVIDE_REASON: "Please provide a reason",
  MIN_CHARACTERS_REQUIRED: (n: number) => {
    return `Minimum ${n} characters required`;
  },
  MAX_CHARACTERS_ALLOWED: (n: number) => {
    return `Max ${n} characters are allowed`;
  },
  FILED_REQUIRED: "This field is required",
  RESTORE_SUBSCRIPTION: "Restore Subscription",
  SUBSCRIPTION_PLANS: "Subscription Plans",
  MONTHLY_PAYMENT: "Monthly payment",
  ANNUALLY_PAYMENT: "Annually payment",
  INVOICES: "Invoices",
  UPCOMING_INVOICES: "Upcoming",
  HISTORY_INVOICES: "History",
  INVALID_URL: "Please enter a valid website URL",
  OR: "or",
};
export default labels;
